/**
 * PATH: packages/ui/src/components/mobile-dock/toMobileDockItems.ts
 * FILE_ID: UI-SHELL-MOBILE-DOCK-ITEMS-MAP-001
 * PURPOSE: Turn a hub sidebar into the shared dock item list.
 * WHY: DashboardLayout must render the same dock the Jobs shell uses.
 * NON-RESPONSIBILITIES: Does not apply entitlement filters. The hub already did.
 * NOTES FOR FUTURE AI: Order is nav, then hubs, then utility. Same as Jobs.
 */

import type { ExternalLink, NavItem } from '../types'
import type { DockItem } from './mobileDockItems'

export function toMobileDockItems(
  navItems: NavItem[] | undefined,
  secondaryNavItems: NavItem[] | undefined,
  hubLinks: ExternalLink[] | undefined,
): DockItem[] {
  const nav: DockItem[] = (navItems ?? [])
    .filter((it) => Boolean(it.href))
    .map((it) => ({
      id: it.id,
      label: it.label,
      icon: it.icon,
      href: it.href as string,
      kind: 'nav' as const,
    }))
  const hubs: DockItem[] = (hubLinks ?? [])
    .filter((link) => Boolean(link.href))
    .map((link, i) => ({
      id: link.id || `hub-${i}`,
      label: link.label,
      icon: link.icon,
      href: link.href,
      kind: 'hub' as const,
      status: link.status,
    }))
  const utility: DockItem[] = (secondaryNavItems ?? [])
    .filter((it) => Boolean(it.href))
    .map((it) => ({
      id: it.id,
      label: it.label,
      icon: it.icon,
      href: it.href as string,
      kind: 'utility' as const,
    }))
  return [...nav, ...hubs, ...utility]
}
